module.exports = __webpack_public_path__ + "img/3.0a38a68c.jpg";